import {Dispatch} from 'redux';
import request, {WISBIT_ORGANIZATION} from 'api/requests/request';
import {clearUser, setUser} from './actions';
import {UserState} from './types';

export const getUser = async (dispatch: Dispatch) => {
  try {
    const res = await request('/user/authenticated', {
      headers: {
        [WISBIT_ORGANIZATION]: '',
      },
    });

    dispatch(setUser(res as UserState));
  } catch (e) {
    dispatch(clearUser());
  }
};
